import React, { useState } from 'react';
import { Card, Text, Button, Input, Spinner } from '@fluentui/react-components';
import { VideoClip24Regular } from '@fluentui/react-icons';

export const PatientSelectionInterface: React.FC = () => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [success, setSuccess] = useState<string | null>(null);

    const handleStartTeamsMeeting = () => {
        if (!email.trim()) {
            setError('Please enter an email address');
            return;
        }

        // Use Teams deep link to start a call
        const teamsCallUrl = `https://teams.microsoft.com/l/call/0/0?users=${encodeURIComponent(
            email
        )}`;
        window.open(teamsCallUrl);

        setSuccess(`Attempting to start Teams call with ${email}`);
    };

    return (
        <div style={{ padding: '24px', maxWidth: '600px', margin: '0 auto' }}>
            <Card style={{ padding: '32px' }}>
                <div style={{ textAlign: 'center', marginBottom: '32px' }}>
                    <VideoClip24Regular
                        style={{ fontSize: '48px', color: '#0078d4', marginBottom: '16px' }}
                    />
                    <Text size={700} weight="bold">
                        Start Teams Meeting
                    </Text>
                    <Text size={300} style={{ color: '#605e5c', marginTop: '8px' }}>
                        Enter an email address to start a Teams meeting
                    </Text>
                </div>

                <div style={{ marginBottom: '24px' }}>
                    <Input
                        placeholder="Enter email address (e.g., test@example.com)"
                        value={email}
                        onChange={(e, data) => setEmail(data.value)}
                        style={{ width: '100%', marginBottom: '16px' }}
                        disabled={loading}
                    />

                    <Button
                        appearance="primary"
                        icon={loading ? <Spinner size="tiny" /> : <VideoClip24Regular />}
                        onClick={handleStartTeamsMeeting}
                        disabled={loading || !email.trim()}
                        style={{ width: '100%' }}
                    >
                        {loading ? 'Creating Teams Meeting...' : 'Start Teams Meeting'}
                    </Button>
                </div>

                {error && (
                    <div
                        style={{
                            padding: '16px',
                            backgroundColor: '#fde7e9',
                            border: '1px solid #f1707b',
                            borderRadius: '4px',
                            marginBottom: '16px',
                        }}
                    >
                        <Text size={300} style={{ color: '#d13438' }}>
                            {error}
                        </Text>
                    </div>
                )}

                {success && (
                    <div
                        style={{
                            padding: '16px',
                            backgroundColor: '#dff6dd',
                            border: '1px solid #107c10',
                            borderRadius: '4px',
                            marginBottom: '16px',
                        }}
                    >
                        <Text size={300} style={{ color: '#107c10', whiteSpace: 'pre-line' }}>
                            {success}
                        </Text>
                    </div>
                )}
            </Card>
        </div>
    );
};
